import SimpleArtist from '@common/types/artist/simple-artist';
import { Option } from '../../types/common/option';

export const RELEASE_MENU_OPTIONS: Option[] = [
  { label: 'Edit Product', value: 'edit' },
  { label: 'Delete Draft', value: 'delete-draft' },
  { label: 'Manage Ownership', value: 'manage-ownership' },
  { label: 'Publish Now', value: 'publish-now' },
  { label: 'Copy Link', value: 'copy-link' },
  { label: 'Takedown Product', value: 'takedown-product' },
  { label: 'Re-Publish', value: 're-publish' },
  { label: 'Delete Product', value: 'delete-product' },
  { label: 'Contest Ownership', value: 'contest-ownership' },
  { label: 'Cancel Publishing', value: 'cancel-publishing' },
];

// TODO: DEVTEAM-603 - getNFTMenuOptions needs to be updated with the new options.
export const getNFTMenuOptions = (nft: any, artist?: SimpleArtist) => {
  return RELEASE_MENU_OPTIONS.filter((option) => {
    switch (option.value) {
      case 'edit':
        return nft.artistId === artist?.id && nft.status !== 'publishing';

      case 'delete-draft':
        return nft.status === 'draft';

      case 'manage-ownership':
        return nft.status === 'processing' || nft.status === 'published';

      case 'publish-now':
        return nft.status === 'publishing';

      case 'copy-link':
        return nft.status === 'processing' || nft.status === 'published';

      case 'takedown-product':
        return nft.status === 'published';

      case 're-publish':
        return nft.status === 'published';

      case 'delete-product':
        return nft.status === 'taken-down';

      case 'contest-ownership':
        return (
          (nft.status === 'processing' || nft.status === 'published') &&
          nft.artistId !== artist?.id
        );

      case 'cancel-publishing':
        return nft.status !== 'draft' && nft.status !== 'processing';
      default:
        return true;
    }
  });
};
